import * as React from "react"

import { cn } from "~/lib/utils"

function Label({ className, ...props }: React.ComponentProps<"label">) {
	return (
		<label
			className={cn(
				"text-foreground/80 peer-disabled:cursor-not-allowed peer-disabled:opacity-70 block text-sm font-medium",
				className
			)}
			{...props}
		/>
	)
}

export { Label }
